<div class="attachments-section">
  <label class="mb-1">Attachments</label>

  <div *ngIf="showPicker" class="attachment-picker mt-2">
    <ng-container *ngIf="standardAttachments.length">
      <p class="font-weight-light fs-13 mb-2">
        Your first standard attachment is included free. Tap to select or deselect.
      </p>
      <div class="attachment-pills mb-3">
        <button
          *ngFor="let attachment of standardAttachments"
          type="button"
          class="attachment-pill attachment-pill-selectable"
          [class.selected]="attachment.selected && !attachment.alreadyInCart"
          [disabled]="attachment.alreadyInCart"
          (click)="selectAttachment(attachment)"
        >
          <span class="attachment-pill-text">
            <span class="attachment-pill-label">{{ attachment.displayName }}</span>
            <span class="attachment-pill-price">{{ priceLabel(attachment) }}</span>
          </span>
          <span
            class="attachment-pill-check"
            *ngIf="attachment.selected && !attachment.alreadyInCart"
            >&check;</span
          >
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="nonStandardAttachments.length">
      <p class="font-weight-light fs-13 mb-2">
        Tap a specialty attachment to select or deselect.
      </p>
      <div class="attachment-pills">
        <button
          *ngFor="let attachment of nonStandardAttachments"
          type="button"
          class="attachment-pill attachment-pill-selectable"
          [class.selected]="attachment.selected && !attachment.alreadyInCart"
          [disabled]="attachment.alreadyInCart"
          (click)="selectAttachment(attachment)"
        >
          <span class="attachment-pill-text">
            <span class="attachment-pill-label">{{ attachment.displayName }}</span>
            <span class="attachment-pill-price">{{ priceLabel(attachment) }}</span>
          </span>
          <span
            class="attachment-pill-check"
            *ngIf="attachment.selected && !attachment.alreadyInCart"
            >&check;</span
          >
        </button>
      </div>
    </ng-container>

    <p
      *ngIf="!standardAttachments.length && !nonStandardAttachments.length"
      class="font-weight-light fs-13 mb-0"
    >
      No attachments are available for this machine.
    </p>
  </div>
</div>
